module.exports = __webpack_public_path__ + "img/tg_01 (1).d06baa5f.jpg";